import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecruitingRoutingModule } from './recruiting-routing.module';
import { CreateLeadComponent } from './create-lead/create-lead.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { UiModule } from "../../ui/ui.module";
import { DropdownModule } from 'primeng/dropdown';
import { TeamsRegisteredComponent } from './teams-registered/teams-registered.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CheckboxModule } from 'primeng/checkbox';
import { TruncatePipe } from 'src/app/ui/pipes/truncate.pipe';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { PromoCodesComponent } from './promo-codes/promo-codes.component';
import { PromoFormComponent } from './promo-form/promo-form.component';
import { SaveButtonComponent } from 'src/app/ui/save-button/save-button.component';
import { SplitterModule } from 'primeng/splitter';
import { LeadSearchComponent } from './lead-search/lead-search.component';
import { RecruitingComponentsModule } from "../../component-modules/recruiting-components/recruiting-components.module";
import { MarketingTouchesDropdownMultiComponent } from "../../ui/dropdowns/marketing-touches-dropdown-multi/marketing-touches-dropdown-multi.component";
import { RecruitingStatusPipe } from 'src/app/ui/pipes/recruitingStatus.pipe';
import { SavedSearchComponent } from 'src/app/ui/saved-search/saved-search.component';
import { NotesModule } from 'src/app/component-modules/notes/notes.module';
import { WebLeadsComponent } from './web-leads/web-leads.component';
import { AssignLeadComponent } from './assign-lead/assign-lead.component';
import { DeleteLeadComponent } from './delete-lead/delete-lead.component';
import { TableSkeletonComponent } from 'src/app/ui/skeletons/table-skeleton/table-skeleton.component';
import {PTripsComponent} from './p-trips/p-trips.component';
import { LocationDropdownComponent } from 'src/app/ui/dropdowns/location-dropdown/location-dropdown.component';
import { DateRangePickerComponent } from 'src/app/ui/date-range-picker/date-range-picker.component';
import { TableCaptionComponent } from 'src/app/ui/tables';

@NgModule({
  declarations: [
    TeamsRegisteredComponent,
    PromoCodesComponent,
    PromoFormComponent,
    LeadSearchComponent,
    WebLeadsComponent,
    AssignLeadComponent,
    DeleteLeadComponent,
    PTripsComponent
  ],
  imports: [
    CommonModule,
    RecruitingRoutingModule,
    DialogModule,
    ButtonModule,
    UiModule,
    ButtonModule,
    FormsModule,
    CheckboxModule,
    ReactiveFormsModule,
    TruncatePipe,
    CalendarModule,
    InputTextModule,
    SaveButtonComponent,
    SplitterModule,
    RecruitingComponentsModule,
    MarketingTouchesDropdownMultiComponent,
    RecruitingStatusPipe,
    SavedSearchComponent,
    NotesModule,
    TableSkeletonComponent,
    LocationDropdownComponent,
    DateRangePickerComponent,
    TableCaptionComponent,
    CreateLeadComponent,
]
})
export class RecruitingModule { }
